import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {ContentHomeOverviewVo} from '../../common/shared/api/nicolas/vo/ContentHomeOverviewVo.interface';

/**
 * 콘텐츠 홈 개요 정보 조회
 *
 * Origin: pageNicolasApi.getContentHomeOverview
 * API: GET /api/v1/content/overview
 */
export async function getContentOverview(
  {
    seriesId,
  }: {
    seriesId: number;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & {result: ContentHomeOverviewVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/content/overview',
    {
      method: 'GET',
      params: {
        series_id: seriesId,
      },
    },
    options
  );
  return response.data;
}
